import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LaudoFotoAdicionalService {

  constructor(private httpClient: HttpClient) { }

  getFotosAdicionais(laudoId): Promise<{ id:any, value:any, label:any}[]> {
    return this.httpClient.get<any[]>(environment.wsUrl + 'laudo/getFotosAdicionais/' + laudoId).pipe().toPromise();
  }

  removeFotoAdicional(id, formId): Promise<any> {
    return this.httpClient.post<any>(environment.wsUrl + 'laudo/removeFotoAdicional/', {id: id, token: formId}).toPromise();
  }

  updateFotoAdicional(descricao, value, file, id, token): Promise<any> {
    let form = new FormData();
    form.append('id', id || '');
    form.append('token', token || '');
    form.append('value', value || '');
    form.append('descricao', descricao || '');
    form.append('file', file || '');
    
    return this.httpClient.post<any>(environment.wsUrl + 'laudo/updateFotoAdicional/', form, 
    { params: { ignore: ['content-type', 'loading'] } }).toPromise();
  }

}
